<template>
  <div
    class="flex items-center justify-center"
    :class="{
      'fixed inset-0 z-999 bg-canvas/70': is_full_page,
      'absolute inset-0 z-29 bg-canvas/70': is_overlay,
    }"
    :style="is_full_page || is_overlay ? null : { height }"
    data-test="app-loader"
  >
    <ProgressSpinner :class="is_small ? 'size-8' : 'size-12'" />
  </div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';

defineProps({
  /** Covers the whole viewport and blocks it, for a wait nothing else on screen can be used during. */
  is_full_page: { type: Boolean },
  /** Covers the nearest positioned parent, for a wait on content that stays visible underneath. */
  is_overlay: { type: Boolean },
  /** A 2rem spinner instead of 3rem, for popovers, side panels and other tight spaces. */
  is_small: { type: Boolean },
  /** Height of the inline box the spinner is centred in. Ignored with `is_full_page` or `is_overlay`. */
  height: { type: String, default: '100px' },
});
</script>
